
function TailwindButton({ label}) {
    return (
  
      <button type="submit" className="py-3 rounded w-full text-center bg-orange-400 text-white hover:bg-green-dark focus:outline-none my-1">{label}</button>
    
   
    );
  }
  
  export default TailwindButton;